/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, forwardRef, inject, input, OnInit } from '@angular/core';
import { AbstractControlValueAccessorGroup } from '@irian-ro/shared-components-module';
import {EnvironmentService} from "@irian-ro/util-environment";
import {FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR} from "@angular/forms";
import {SubscriptionTypeDtoModel} from "@well/domain";
import {CurrencyService} from "@well/price-management";
import {SelectItem} from "primeng/api";
import {constants} from "@well/infra/constants";
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

@Component({
  selector: 'well-subscription-type-inputs',
  templateUrl: './subscription-type-inputs.component.html',
  styleUrls: ['./subscription-type-inputs.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SubscriptionTypeInputsComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => SubscriptionTypeInputsComponent),
      multi: true
    }
  ]
})
export class SubscriptionTypeInputsComponent extends AbstractControlValueAccessorGroup implements OnInit {
  isEditMode = input<boolean>(false);

  environmentService = inject(EnvironmentService);

  placeholder = 'Nume sau CUI';

  legalEntitySearchLocation: 'ANAF' | 'ALL' = 'ALL';

  currencySelectItems: SelectItem[] | undefined = undefined;

  companyTypeSelectItems: SelectItem[] | undefined = undefined;

  constructor(private currencyService: CurrencyService) {
    super();
  }

  ngOnInit() {
    this.currencySelectItems = this.currencyService.getCurrencySelectItems();
    this.companyTypeSelectItems = constants.companyTypeList;
    if (!this.environmentService.getEnvironmentProperty("accessUnavailableFeatures")) {
      this.companyTypeSelectItems = this.companyTypeSelectItems.filter(item => item.value !== CompanyType.customer_with_fleet);
    }
  }

  writeValue(obj: any): void {
    if (obj) {
      this.form.patchValue(obj, { emitEvent: false });
    }
  }

  protected createForm() {
    this.form = SubscriptionTypeDtoModel.createForm();
  }

  getPrivateControl() {
    return this.form.controls['private'] as FormControl;
  }
}
